<template>
	<div class="Score">
		<div class="container">
			<div class="row">
				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
					<div @click="goToCourse" class="goToLesson"><a href="#">Go Back To Video</a></div>
					<div class="your-score">You Scored
						<div class="out-of-score">{{ getScore }}/{{getTotalQuizCount}}</div>
						<div class="score-level" v-if="getScore > (getTotalQuizCount / 2) + 3">EXPERT</div>
						<div class="score-level" v-else-if="getScore < (getTotalQuizCount / 2) - 4">Beginner</div>
						<div class="score-level" v-else>Intermediate</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Score',

  computed: {
    ...mapGetters(['getScore', 'getTotalQuizCount']),
  },
  props: {
    score: {
      type: Number,
    },
  },
  methods: {
    goToCourse() {
      this.$router.push('/home');
    },
  },
};
</script>

<style lang="scss" scoped>
.Score {
  background: #fafdff none repeat scroll 0 0;
  text-align: center;
  padding-top: 100px;
  position: relative;
  min-height: 80vh;
  top: 35px;

  .goToLesson {
    margin: 0;
  }

  .goToLesson > a {
    color: #54a3ff;
    font-size: 20px;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
  }
  .your-score {
    color: #7e8b9c;
    font-size: 48px;
    line-height: 100%;
    font-weight: normal;
    margin-top: 40px;
  }
  .out-of-score {
    color: #28282e;
    font-size: 72px;
    margin: 60px 0 70px;
  }
  .score-level {
    background: rgba(0, 0, 0, 0) linear-gradient(253deg, #ffa26a, #ff4064)
      repeat scroll 0 0;
    border-radius: 3px;
    color: #ffffff;
    display: inline-block;
    font-family: "Roboto", sans-serif;
    font-size: 28px;
    font-weight: normal;
    height: 60px;
    letter-spacing: 2px;
    line-height: 60px;
    margin: 0 auto 100px;
    padding: 0 60px;
  }

}
</style>


// WEBPACK FOOTER //
// src/modules/Quiz/components/Score.vue